import AcServices from "../modules/ac-services";
export const initAcServices = () => {
    if (!window.AC_SERVICES) {
        window.AC_SERVICES = new AcServices();
    }
    return window.AC_SERVICES;
};
